import { withNaming } from "@bem-react/classname";

export const bem = withNaming({ n: "", e: "__", m: "--", v: "-" });
